import { createDraft, finishDraft } from 'immer';
import { WritableDraft } from 'immer/dist/internal';
import { v4 as uuid } from 'uuid';

import { FlowMessengerNodeSubflowReference } from 'components/settings/components/sections/dixaMessenger/views/flow/flow.types';

export class SubflowReferenceNode {
  private muteableReferenceNode: WritableDraft<FlowMessengerNodeSubflowReference>;

  constructor(referenceNode: FlowMessengerNodeSubflowReference) {
    this.muteableReferenceNode = createDraft(referenceNode);
  }

  getReferenceNode(): FlowMessengerNodeSubflowReference {
    return finishDraft(this.muteableReferenceNode);
  }

  hasPortWithReturnId(returnId: string): boolean {
    return this.muteableReferenceNode.payload.exits.hasOwnProperty(returnId);
  }

  createNewExitForReturnId(returnId: string): void {
    this.muteableReferenceNode.payload.exits[returnId] = {
      nextNodeId: uuid(),
    };
  }

  getExitIdsList(): string[] {
    return Object.keys(this.muteableReferenceNode.payload.exits);
  }

  deleteExitById(exitId: string): void {
    delete this.muteableReferenceNode.payload.exits[exitId];
  }

  deleteAllExits(): void {
    this.muteableReferenceNode.payload.exits = {};
  }
}
